import PropTypes from 'prop-types';

export default {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.number,
  assignee_name: PropTypes.string,
  assignee_id: PropTypes.number,
  assignee_type: PropTypes.string,
  note: PropTypes.string,
  status: PropTypes.string,
  kind: PropTypes.string,
  created_at: PropTypes.string,
  errors: PropTypes.shape({
    total: PropTypes.array,
    note: PropTypes.array,
    status: PropTypes.array,
    kind: PropTypes.array,
  }),
};



// WEBPACK FOOTER //
// ./client/app/shared/types/contractorChargebackItem.js